import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  table: {
    minWidth: 650,
  },
  createScheduleWrap: {
    maxWidth: '960px',
  },
  contentSettingWrap: {
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(3),
    padding: theme.spacing(3),
  },
  sectionTitle: {
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  infoTextField: {
    width: '100%',
    paddingBottom: theme.spacing(3.8),
  },
  radioButtonGroups: {
    flexDirection: 'row',
    '& > label': {
      flex: '1',
    },
    marginBottom: theme.spacing(3),
  },
  inputLabel: {
    fontSize: 15,
    transform: 'scale(1)',
    color: '#212121',
  },
  tfInput: {
    paddingTop: 10,
  },
  tableCell: {
    maxWidth: '150px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  utcTime: {
    color: '#666',
    fontSize: 9,
  },
  tdDelete: {
    width: 90,
  },
  tdDate: {
    width: 200,
  },
  tdId: {
    maxWidth: 100,
  },
  tdTitle: {
    fontWeight: 500,
  },
  scIn: {
    backgroundColor: '#fff4ff',
  },
  scYet: {
    backgroundColor: '',
  },
  scEnd: {
    backgroundColor: '',
  },
  statusIcon: {
    fontSize: '0.5rem',
  },
  statusScheduled: {
    color: '#00d29c',
  },
  statusLive: {
    color: '#00d29c',
  },
  statusExpired: {
    color: '#d6d6d6',
  },
}));

export default useStyles;
